import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Particles from 'react-particles';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

export default function MaintenanceCountdown() {
  const theme = useTheme();
  const [countdownText, setCountdownText] = useState('');
  const countdownDate = new Date('Aug 25, 2026 03:00:00').getTime();

  useEffect(() => {
    const countdown = () => {
      const now = new Date().getTime();
      const distance = countdownDate - now;

      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setCountdownText(hours + 'h ' + minutes + 'm ' + seconds + 's ');

      if (distance < 0) {
        clearInterval(x);
        setCountdownText(0 + 'h ' + 0 + 'm ' + 0 + 's ');
      }
    };

    const x = setInterval(function () {
      countdown();
    }, 1000);

    countdown();

    return () => {
      clearInterval(x);
    };
  }, []);

  return (
    <>
      <div style={{ flex: '1 1 auto', display: 'grid', justifyItems: 'center', alignItems: 'center', position: 'relative', overflow: 'hidden', isolation: 'isolate', userSelect: 'none' }}>
        <div style={{ display: 'grid', justifyItems: 'center', alignItems: 'center', gap: 20, textAlign: 'center' }}>
          <RocketLaunchIcon style={{ fontSize: 150, textShadow: '11px 2px 7px rgb(22 22 22 / 36%)' }} />
          <div style={{ fontSize: 40 }}>Scheduled Maintenance in Progress</div>
          <div style={{ width: 500 }}>
            We are working to enhance your experience! Our website is currently undergoing maintenance to bring you new features and improvements. We apologize for any inconvenience this may cause.
            The maintenance is expected to be completed by
          </div>
          <div style={{ fontSize: 70, fontWeight: 'bold', borderBottom: '5px solid', borderColor: theme.palette.primary.main, fontFamily: '"nasalization", sans-serif' }}>{countdownText}</div>
          <div style={{ fontSize: 20 }}>Thank you for your patience!</div>
        </div>
        <div
          style={{
            width: '100%',
            height: '100%',
            background: 'linear-gradient(180deg, rgba(0,0,0,0) 25%, rgba(48,48,48,1) 40%)',
            zIndex: -1,
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        ></div>
      </div>
    </>
  );
}
